

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {
    }
    if (process.env.APP_ID == 'account') {
const { default: LiverpoolFooter } = await import('@brainjam/liverpool-frontend-component-footer');
      addPlugins(config, 'footer_slot', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'default_contents',
                    type: DIRECT_PLUGIN,
                    priority: 1,
                    RenderWidget: <LiverpoolFooter />,
                },
            },
            ]);
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
const { default: LiverpoolFooter } = await import('@brainjam/liverpool-frontend-component-footer');
      addPlugins(config, 'footer_slot', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'default_contents',
                    type: DIRECT_PLUGIN,
                    priority: 1,
                    RenderWidget: <LiverpoolFooter />,
                },
            },
            ]);
    }
    if (process.env.APP_ID == 'learning') {
const { default: LiverpoolFooter } = await import('@brainjam/liverpool-frontend-component-footer');
      addPlugins(config, 'footer_slot', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'default_contents',
                    type: DIRECT_PLUGIN,
                    priority: 1,
                    RenderWidget: <LiverpoolFooter />,
                },
            },
            ]);
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
const { default: LiverpoolFooter } = await import('@brainjam/liverpool-frontend-component-footer');
      addPlugins(config, 'footer_slot', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'default_contents',
                    type: DIRECT_PLUGIN,
                    priority: 1,
                    RenderWidget: <LiverpoolFooter />,
                },
            },
            ]);
    }
// Liverpool Dental: Reorder CSS loading for structural overrides
// Moves brandOverride CSS to load AFTER app.css
if (true) {
  (function reorderBrandOverrideCSS() {
    'use strict';

    let hasReordered = false;

    function attemptReorder() {
      if (hasReordered) return;

      try {
        // Find the MFE's bundled app.css (ends with app.[hash].css)
        const stylesheets = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
        const appCss = stylesheets.find(link =>
          link.href &&
          link.href.match(/\/app\.[a-f0-9]+\.css$/)
        );

        if (!appCss) {
          return; // app.css not ready yet, wait for next mutation
        }

        // Find all Liverpool brandOverride stylesheets
        // These have data-brand-theme-* attributes added by useParagonTheme hooks
        const brandSheets = document.querySelectorAll(
          'link[data-brand-theme-core], link[data-brand-theme-variant]'
        );

        if (brandSheets.length === 0) {
          return; // brandOverride stylesheets not injected yet, wait for next mutation
        }

        // We have both app.css and brandOverride sheets - reorder them!
        let lastElement = appCss;
        brandSheets.forEach(sheet => {
          sheet.remove();
          lastElement.insertAdjacentElement('afterend', sheet);
          lastElement = sheet; // Stack them in order
        });

        hasReordered = true;
        console.info(
          '[Liverpool CSS Reorder] Success! ' +
          'brandOverride CSS now loads AFTER app.css. ' +
          `Reordered ${brandSheets.length} stylesheet(s).`
        );

        // Stop observing once we've successfully reordered
        if (observer) {
          observer.disconnect();
        }

      } catch (error) {
        console.error('[Liverpool CSS Reorder] Failed:', error);
      }
    }

    // Watch for stylesheets being added to <head>
    const observer = new MutationObserver(() => {
      attemptReorder();
    });

    // Start observing as soon as possible
    if (document.head) {
      observer.observe(document.head, {
        childList: true,
        subtree: true
      });
    }

    // Also try immediately in case stylesheets are already present
    attemptReorder();

    // Fallback: try again after DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attemptReorder);
    }
  })();
}
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;